export const LeadCampaignType = Object.freeze({
  UNKNOWN: "Unknown",
  CAMPAIGN: "Campaign",
  AD_SET: "AdSet",
  AD: "Ad",
  FORM: "Form",
  BOT: "Bot",
});

export const LEAD_CAMPAIGN_TYPES = Object.values(LeadCampaignType);

export function normalizeLeadCampaignType(value) {
  if (value == null || value === "") return null;
  if (LEAD_CAMPAIGN_TYPES.includes(value)) return value;
  const index = Number(value);
  return Number.isInteger(index) ? LEAD_CAMPAIGN_TYPES[index] || null : null;
}

export function leadCampaignTypeOptions(translate) {
  return LEAD_CAMPAIGN_TYPES.map((value) => ({
    value,
    label: translate(`leadSource.campaigns.types.${value}`),
  }));
}
